
import {defineComponent, reactive, ComputedRef, computed} from 'vue';
import { NoticeBar } from 'scvant';
import {useRoute} from "vue-router";
import {GetDetectPreview} from '@/service';
import plugin from '@/util/plugin.js';
import reportConformCarInfo from './components/carInfo.vue';
import reportContent from './components/reportContent.vue';
// import reportPicItem from './components/reportPicItem.vue';

interface State {
    // carInfo: object;
    // reportData: object;
    // paintResult: object[];
    // renderList: object[];
    data: object;
}


export default defineComponent({
    name: 'reportConfirm',
    components: {
        [NoticeBar.name]: NoticeBar,
        reportConformCarInfo,
        reportContent
    },
    setup() {
        let state: State = reactive({
            data: {
                reportData: {},
                // carInfo: {},
                paintResult: [],
                detectType: ''
            }
            
        });
        const {query} = useRoute();
        const {reportCode, token} = query
        GetDetectPreview({
            reportCode: reportCode,
            token: token
        }).then((res: any) => {
            console.log(res);
            state.data = {
                reportData :res,
                paintResult :res.paintResult,
                detectType: res.checkInfo.itemTitle === '环车检测' ? 'huanchejian' : ''
            }
            // state.reportData = res;
            // state.paintResult = res.paintResult
            // state.carInfo = res.;

        }).catch()
        const u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        return {
            state,
            isAndroid
        }
    },
    // onCreated(){
        // this.getDetectPreviewHandler();
    // },
    methods: {
        refresh() {
            window.location.reload();
        },
        goToDetectPage() {
            let param = {
                methodName: 'goToModify',
                data: {
                    type: this.state.data['detectType']
                }
            }
            plugin.appFunHandler(param, ()=> {
                console.log('调用完成');
            });
        }
    }
});
